import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import StageHeader from '../../components/stageHeader';
import Datepicker from 'vuejs-datepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './shipmentCconfirmation.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import PayMethod from '../../components/payMethod';
import tmsService from '../../services/axios/tmsService';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import qs from 'qs';
import localStorageUtil from '../../services/localStorageUtil/localStorageUtil';
import AddPayment from '../../components/addPayment';
import { forEach, map, add, isNumber, ceil } from 'lodash-es';
@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        PayMethod,
        AddPayment,
    },
})
export default class ShipmentCconfirmation extends Vue {
    truckloadForm: any = {};
    aaa: any = '23';
    aab: any = '';
    freightChargesBillTo: any = 3;
    editProductModal: string = 'shipmentConfirmed';
    editDetals: any = {
        Pickup: false,
        Delivery: false,
        Invoice: false,
    };
    quoteInfo: any = {};
    getQuoteId: any = '';
    quoteId: any = '';
    orderParams: any = {};
    quoteLine: any = {};
    shipments: any = {};
    quoteInfoLines: any = {};
    showErrTip: boolean = false;
    errorText: String = '';
    canPlaceOrder: Boolean = true;
    acceptService: Boolean = false;
    orderId: any = '';
    tipType: string = '';
    pickupService: any = '';
    deliveryService: any = '';
    payMethod: any = '';
    refreshPaymethodList: Boolean = false;

    created() {
        this.quoteId = this.$route.params.id;
        this.getQuoteId = this.$route.params.quoteId;
        this.getQuoteInfo();
        this.getProducts();
        this.getOverview();
    }

    getOverview() {
        return new Promise((resolve, reject) => {
            tmsServiceBackend.post(`order/getOrderDetail?order_id=${this.quoteId}`).then(
                (res: any) => {
                    this.quoteLine = res.data.data;
                    this.orderId = this.quoteLine.order_id;
                    if (this.quoteLine.shipment_code == 'PL') {
                        this.pickupService = 'Liftgate';
                    }
                    if (this.quoteLine.shipment_code == 'DL') {
                        this.deliveryService = 'Liftgate';
                    }
                },
                (err: any) => {
                    this.err(err.response.data.statusText);
                    reject({});
                }
            );
        });
    }

    getProducts() {
        let param: any = {
            order_id: this.quoteId,
        };
        tmsServiceBackend.post(`/cpv2/shipment/getProducts`, qs.stringify(param)).then(
            (res: any) => {
                if (res.data.data) this.shipments = res.data.data;
            },
            (err: any) => {
                this.err(err.response.data.message);
            }
        );
    }

    getQuoteInfo() {
        tmsService
            .post(
                `/write_new/get_tms_quote_line.php`,
                qs.stringify({ quote_id: this.getQuoteId, include_fee_quote_lines: 1 })
            )
            .then(
                (res: any) => {
                    this.quoteInfoLines = res.data;
                    forEach(this.quoteInfoLines.m_lines, (item: any) => {
                        if (item.shipment_code == 'PL') {
                            this.pickupService = 'Liftgate';
                        } else if (item.shipment_code == 'DL') {
                            this.deliveryService = 'Liftgate';
                        }
                    });
                },
                (err: any) => {
                    this.err(err.response.data.statusText);
                }
            );
    }

    editProductAction(index: any) {}

    closeModal() {
        this.$modal.hide(this.editProductModal);
        this.$router.push({
            name: 'shipment',
        });
    }

    goBackEditPage() {
        this.$router.push({
            name: 'ScheduleApickup',
            params: {
                quoteId: this.quoteId,
            },
        });
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
            this.tipType = '';
        }, 3000);
    }

    goBolCreatePage() {
        if (!this.orderId) {
            this.err('param error.');
            return;
        }
        this.$router.replace({
            name: 'Billoflading',
            params: {
                orderId: this.orderId,
            },
        });
    }

    viewShipmentList() {
        this.$router.push({
            name: 'Shipment',
        });
    }

    selectPayMethod() {}

    addPayMethod() {
        this.editProductModal = 'addPayMethodDom';
        this.$modal.show(this.editProductModal);
    }

    addNewPayment() {
        this.$modal.hide(this.editProductModal);
        this.refreshPaymethodList = true;
    }

    coentTotalAmout(quoteInfoLines: any) {
        let LineAmountTotals = map(quoteInfoLines.lines, 'rate_amount_total');
        let totalAmout = 0;
        forEach(LineAmountTotals, amout => {
            if (isNumber(amout)) {
                totalAmout = add(totalAmout, amout);
            } else {
                totalAmout = add(totalAmout, Number(amout));
            }
        });
        return totalAmout;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipmentCconfirmation/index.ts